import React from "react";
import { AdminFEDashboard } from "./AdminFEDashboard";

export function Dashboard() {
  return <AdminFEDashboard />;
}
